import { useQuery } from '@tanstack/react-query';
import { authApi } from '@/lib/api';
import { queryKeys } from './shared';

// Auth
export const useMe = (enabled: boolean = true) =>
  useQuery({
    queryKey: queryKeys.me,
    queryFn: authApi.getMe,
    retry: false,
    enabled,
  });
